import TruckMoving from '../../src/legacy/TruckMoving.tsx';
export default TruckMoving;
